import Icon from '../components/Icon.vue'

Icon.register({"forward":{"width":512,"height":512,"paths":[{"d":"M500.5 231.4L308.5 71.4C287.9 54.3 256 68.6 256 96V416C256 443.4 287.9 457.8 308.5 440.6L500.5 280.6C515.8 267.8 515.8 244.2 500.5 231.4zM244.5 231.4L52.5 71.4C31.9 54.3 0 68.6 0 96V416C0 443.4 31.9 457.8 52.5 440.6L244.5 280.6C259.8 267.8 259.8 244.2 244.5 231.4z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/forward.js
// module id = ItUA
// module chunks = 0